export const environment = {
  production: false,
  baseUrl: '/tis/',
  ADOBE_LAUNCH_SCRIPT_URL: 'https://assets.adobedtm.com/4ec2f85e3dde/88ae5a07f98a/launch-78d9d3d32e1a-staging.min.js',
  env: 'staging'
};
